module.exports = __webpack_public_path__ + "img/24_64.cb2b7fdd.png";